import {isNil} from 'ramda';

import {CustomerMessageResponseBody} from '@dms/api/core';

import {MessageDayGroup} from '../types/MessageDayGroup';

export function findParentMessage(
  groups: MessageDayGroup[],
  message: CustomerMessageResponseBody
): CustomerMessageResponseBody | null {
  if (isNil(message.parentEmailMessageId)) {
    return null;
  }

  // Search rendered groups so a loaded parent is also a scrollable card.
  return (
    groups
      .flatMap((group) => group.messages)
      .find((candidate) => candidate.emailMessageId === message.parentEmailMessageId) ?? null
  );
}
